import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { PhoneCall, ShieldCheck, Sun, Moon } from "lucide-react";

const links = [
  { label: "Services", href: "#services" },
  { label: "Work", href: "#gallery" },
  { label: "Reviews", href: "#reviews" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar({ theme, onToggle }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (e, href) => {
    e.preventDefault();
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${scrolled ? "glass py-3" : "py-5"}`}
      data-testid="main-navbar"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 flex items-center justify-between">
        <a href="#top" onClick={(e) => go(e, "#top")} className="flex items-center gap-2.5" data-testid="nav-logo">
          <span className="w-9 h-9 rounded-lg bg-cyan-500/10 border border-cyan-400/40 flex items-center justify-center">
            <ShieldCheck className="w-5 h-5 text-cyan-400" />
          </span>
          <span className="font-display font-800 tracking-tight text-lg font-extrabold">
            ANAYA<span className="text-cyan-400">.</span>
            <span className="hidden sm:inline font-mono2 text-[10px] text-strong0 ml-2 tracking-[0.2em]">CCTV SECURITY</span>
          </span>
        </a>
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => go(e, l.href)}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="font-mono2 text-xs uppercase tracking-[0.18em] text-soft hover:text-cyan-400 transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <button
          onClick={onToggle}
          data-testid="theme-toggle-button"
          aria-label="Toggle light and dark theme"
          className="w-10 h-10 rounded-full border border-line flex items-center justify-center text-soft hover:text-cyan-400 hover:border-cyan-400/50 transition-colors duration-300"
        >
          {theme === "dark" ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
        </button>
        <a
          href="tel:7011364764"
          data-testid="nav-call-button"
          className="flex items-center gap-2 bg-cyan-500 hover:bg-cyan-400 text-on-accent font-semibold text-sm px-4 sm:px-5 py-2.5 rounded-full transition-colors duration-300"
        >
          <PhoneCall className="w-4 h-4" />
          <span className="hidden sm:inline">70113 64764</span>
          <span className="sm:hidden">Call</span>
        </a>
      </div>
    </motion.header>
  );
}
